export default __webpack_public_path__ + "images/d212c438328cdcf0e4c1f2e150077189-rugby.jpg";